import script from "./index.vue?vue&type=script&lang=tsx&setup=true"
export * from "./index.vue?vue&type=script&lang=tsx&setup=true"

import "./index.vue?vue&type=style&index=0&id=78cb729f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78cb729f"]])

export default __exports__